enum ApiNotifType {
    System = 1,
    Data = 2,
    Service = 4,
    Dico = 32
}

export default ApiNotifType;